import { Lineitem } from '../../../interfaces/Ordel.Interface';

/**
 * Accumulate paginated results for the delivery board's Load More flow,
 * REFRESHING any item the fetched page carries again instead of keeping the
 * object first seen. The append-only merge froze every card at its first
 * load: one loaded before a special cleaning was applied never gained
 * cleaning_requirement, so the confirm dialog never showed and the server
 * rejected every submit with no way out short of reloading the app.
 */
export function mergeDeliveryPages(
	previous: Lineitem[],
	incoming: Lineitem[]
): Lineitem[] {
	const byId = new Map(incoming.map((item) => [item.id, item]));
	const refreshed = previous.map((item) => byId.get(item.id) ?? item);
	const known = new Set(previous.map((item) => item.id));
	const appended = incoming.filter((item) => !known.has(item.id));
	return [...refreshed, ...appended];
}
